export function NotFoundComponent(){
    return <div className="p-5 text-center">
    <h2>404</h2>
    <h3>Página desconhecida.</h3>
  </div>
}